
import { useState, useContext, useEffect } from 'react';
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import DepartamentContext from "context/DepartamentContext";
import ErrorMessage from 'components/ErrorMessage';

const DEPARTAMENT_VALUES = {
    codLogistica: '',
    departamento: '',
    ciudad: '',
    estado: false
}
function Form({ createDepartament, updateDepartament, setIsSearched }) {
    const { departament: selectedDepartament, setDepartament: setSelectedDepartament, message, setMessage } = useContext(DepartamentContext);

    const [form, setForm] = useState(DEPARTAMENT_VALUES);
    const { codLogistica, departamento, ciudad, estado } = form;

    let myAbi = HelpAbility();
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    const handleChangeBool = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value === 'true' });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let status = Object.keys(selectedDepartament).length ? await updateDepartament({ departament: form, id: selectedDepartament._id }) : await createDepartament({ departament: form })
        if (!status) {
            setIsSearched({
                search: '',
                option: '',
                state: false
            })
            setForm(DEPARTAMENT_VALUES)
            setSelectedDepartament({});
            setMessage({ message: '', status: 200 })
        }
    }

    const handleReset = () => {
        setForm(DEPARTAMENT_VALUES)
        setSelectedDepartament({});
        setMessage({ message: '', status: 200 })
    }

    const isVisibleForm = Object.keys(selectedDepartament).length ? myAbi.has(C.A.DEPARTAMENT.UPDATE) : myAbi.has(C.A.DEPARTAMENT.CREATE);

    useEffect(() => {
        if (!Object.keys(selectedDepartament).length) return null;
        setForm(selectedDepartament)
    }, [selectedDepartament])

    return (
        <>
            {isVisibleForm
                &&

                <div className="mt-4">
                    <div className="row mb-2">
                        <h6>{Object.keys(selectedDepartament).length ? 'Editar' : 'Agregar'} Departamento</h6>
                    </div>
                    {message.status !== 200 && message.message && <ErrorMessage message={message.message}></ErrorMessage>}
                    <div className="table-responsive rounded-3"
                        style={{ border: '1px solid black', paddingTop: '15px' }}>
                        <div className="row mb-3 d-flex justify-content-center">
                            <div className="col-3 themed-grid-col" style={{ paddingRight: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="codLogistica" className="form-label">Código Logístico</label>
                                    <input type="number" className="form-control" id="codLogistica"
                                        name="codLogistica" autoComplete="off" value={codLogistica} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="departamento" className="form-label">Departamento</label>
                                    <input type="text" className="form-control" id="departamento" name="departamento" autoComplete="off"
                                        value={departamento} onChange={handleChange} />
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col" style={{ paddingLeft: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="ciudad" className="form-label">Municipio</label>
                                    <input type="text" className="form-control" id="ciudad" name="ciudad"
                                        autoComplete="off"
                                        value={ciudad} onChange={handleChange} />
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="name" className="form-label">Disponible</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="estado"
                                                onChange={handleChangeBool}
                                                checked={estado === true} id="isVisible-radio-true"
                                                value={true} />
                                            <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="estado"
                                                onChange={handleChangeBool}
                                                checked={estado === false} id="isVisible-radio-false"
                                                value={false} />
                                            <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col ms-2" style={{ paddingLeft: '10px' }}>
                                <button className={'d-block d-block w-100 mb-2 btn btn-' + (true ? 'success' : 'primary')} type="submit"
                                    onClick={handleSubmit}><i
                                        className="bi bi-save" />{Object.keys(selectedDepartament).length ? 'Actualizar' : 'Guardar'}</button>
                                <button type="reset" className="d-block w-100 btn btn-secondary" onClick={handleReset}><i
                                    className="bi bi-eraser" /> Limpiar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default Form
